<!--
--
-- Display certificate upload Dialog
--
-->

<template>
  <v-layout row justify-left>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{$t('attributes.importCertificateDialogTtitle')}}</v-card-title>
        <v-card-text>
            <my-input-file name="certificateString" :model="uploadCertificate" v-validate="'required'" :certificateIsValid='certificateIsValid'/>
            <my-input name="certificatePassword" :model="uploadCertificate" v-validate="'required'"/>
            <v-text-field name="uploadResult" :class="{ 'my-text-style': showUploadResult }" :value="uploadResult" v-show="showUploadResult" readonly/>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="hideDialog()">{{ btnText }}</v-btn>
            <v-btn color="primary" @click="submit()" :disabled="submitState()">{{ $t("attributes.importCertificateSave") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
    import WebService from "@/services/WebService"
    import MyInputFile from '@/components/MyInputFile.vue'
    import MyInput from '@/components/MyInput.vue'

    export default {
        name: 'my-company-certificate-dialog',

        components: {
            MyInput, MyInputFile
        },

        props: ['companyId'],

        data: () => ({
            dialog: true,
            certificateIsValid: true,
            uploadResult: null,
            showUploadResult: false,
            webService: new WebService(this),
            uploadCertificate: {
                traderIdentificationNumber: null,
                certificateString: null,
                certificatePassword: null
            },
            btnText: null,
        }),

        methods: {
            submitState() {
                if ( (this.uploadCertificate.certificateString) && (this.uploadCertificate.certificatePassword))
                    return false
                else
                    return true
            },

            submit()
            {
                this.uploadCertificate.traderIdentificationNumber=this.companyId
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.checkCertificate().then(checkResult => {
                            this.certificateIsValid = checkResult
                            if (checkResult) {
                                this.webService.updateCertificate(this.uploadCertificate)
                                    .then(response => {
                                        if (response.request.status == 204) {
                                            console.log("response" + response.data)
                                            this.uploadResult=this.$t("attributes.importCertificateOK")
                                            this.showUploadResult=true
                                            this.btnText=this.$t('attributes.importCertificateSaved')
                                            this.uploadCertificate.certificateString=null
                                            this.uploadCertificate.certificatePassword=null
                                        } else {
                                            this.uploadResult=this.$t("attributes.importCertificateFail")
                                            this.showUploadResult=true
                                            this.$store.dispatch('setError', response.data)
                                        }
                                    }).catch(e => {
                                        console.log(e)
                                        this.uploadResult=this.$t("attributes.importCertificateFail")
                                        this.showUploadResult=true
                                        this.$store.dispatch('setError', e)
                                })
                            }
                        })
                    }
                });
            },

            hideDialog() {
                this.$emit('hide-company-certificate-dialog');
            },

            checkCertificate() {
                return this.webService.checkCertificate(this.uploadCertificate).then((response) => {
                    return response.data
                }).catch(error => {
                    console.log(error)
                    return false;
                })
            }

        },

        mounted() {
            this.btnText=this.$t('attributes.cancel')
        }
    }
</script>

<style scoped>
    .my-text-style >>> .v-text-field__slot input {
        color: green
    }
</style>
